import React from 'react';
import styled from 'styled-components';
import { Header } from '../Header/Header';
import { Footer } from '../Footer/Footer';
import { A11Y } from '../../../utils/constants';

const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const SkipLink = styled.a`
  position: absolute;
  top: -40px;
  left: 6px;
  background: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.white};
  padding: 8px;
  text-decoration: none;
  z-index: ${({ theme }) => theme.zIndex.modal};
  border-radius: 4px;
  
  &:focus {
    top: 6px;
  }
`;

const MainContent = styled.main`
  flex: 1;
  outline: none;
`;

interface LayoutProps {
  children: React.ReactNode;
  heroProps?: {
    backgroundImage?: string;
    logo?: string;
    title?: string;
    description?: string;
  };
}

export const Layout: React.FC<LayoutProps> = ({ children, heroProps }) => {
  return (
    <LayoutContainer>
      <SkipLink href="#main-content">
        {A11Y.SKIP_LINK_TEXT}
      </SkipLink>
      
      <Header {...heroProps} />
      
      <MainContent id="main-content" tabIndex={-1}>
        {children}
      </MainContent>
      
      <Footer />
    </LayoutContainer>
  );
};

export default Layout;
